export default __webpack_public_path__ + "static/media/pic1.5c90e2e5.jpg";